import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import fr from 'facet-rest';
import SurveyStepHeader from 'Views/Onboarding/Components/SurveyStepHeader';
import WhatIfStepNavigator from 'Views/Page/Content/Modal/Components/WhatIfStepNavigator';
import Typography from 'Components/UI/Typography';

const styles = () => ({
  root: {},
  confirmationPromptBox: {
    display: 'flex',
    textAlign: 'center',
    justifyContent: 'center',
  },
  confirmationPrompt: {
    width: '50%',
  },
});

const StrategyResetConfirmation = ({
  className,
  classes,
}) => {
  const { onSubmit, saving } = useMetaLayoutContext(); // onSubmit
  const { modalCollection, loadModalCollectionByLink } = useModalContext();

  // In this case we are using a collection as the meta layout context resource
  const resourceHead = modalCollection.resources().head();
  const previousLink = resourceHead.relationship(fr.relationships.previousLink.name)?.link('related');

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <SurveyStepHeader
        title={resourceHead.attr('title')}
        subtitle={resourceHead.attr('subtitle')}
      />
      <Box className={classes.confirmationPromptBox}>
        <Typography className={classes.confirmationPrompt}>
          {resourceHead.attr('confirmationPrompt')}
        </Typography>
      </Box>
      <WhatIfStepNavigator
        isLoading={saving}
        onNext={() => {
          onSubmit();
        }}
        onPrevious={(previousLink) ? () => {
          loadModalCollectionByLink(previousLink.url());
        } : null}
      />
    </Box>
  );
};

StrategyResetConfirmation.defaultProps = {
  className: '',
};

StrategyResetConfirmation.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(StrategyResetConfirmation);
